export enum AnonymousStudentErrorType {
	UNAUTHORIZED = 'StudentAPIUnauthorizedError',
	STUDENT_NOT_FOUND_ERROR = 'StudentAPIStudentNotFoundError',
	VALIDATION_ERROR = 'StudentAPIValidationError',
	UNKNOWN_ERROR = 'StudentAPIUnknownError',
	SESSION_NOT_FOUND_ERROR = 'StudentSessionNotFoundError',
}
